module.exports = {
  title: 'GL Transitions with Skia',
  author: 'Enzo Manuel Mangano',
  date: '2024-03-20',
  slug: 'gl-transitions',
  tags: ['skia', 'reanimated'],
};
